import { Box,Autocomplete,TextField,Button, Typography,Select,MenuItem} from '@mui/material'
import React,{useState,useEffect} from 'react'
import useSound from 'use-sound';
import rainSound from '../assets/sounds/rain.mp3'
import fireSound from '../assets/sounds/fireplace.mp3'
import waveSound from '../assets/sounds/waves.mp3'
import gongSound from '../assets/sounds/gong.mp3'
import thetaSound from '../assets/sounds/Theta_binaural.mp3'
import deltaSound from '../assets/sounds/Delta_binaural.mp3'
import alphaSound from '../assets/sounds/Alpha_binaural.mp3'
import omSound from '../assets/sounds/Tibetan.mp3'
import Sound from 'react-sound';
import backGround from '../assets/giphy4.gif'

const soundList=[
  'No sound','Rain','Fire','Waves','Theta Binaural','Delta Binaural','Alpha Binaural','Tibetan Om']



const selectStyle={
  width: {xs:'70%',sm: '50%',md:'40%',lg:'30%'},
  
  color: 'primary.light',
  "& .MuiSvgIcon-root": {
    color: "white",
},
  'label + &': {
    marginTop: 0,
    // color: 'white'
  },
  '& .MuiInputBase-input': {
    borderRadius: 1,
    // position: 'relative',
    backgroundColor: 'rgba(1,1,1,0.7)',
    color: 'white',
    border: 2,
    borderColor:'primary.main',
    fontSize: 16,
    // padding: '10px 26px 10px 12px',
    
    // transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      
    ].join(','),
    '&:focus': {
      
      borderColor: 'primary.main',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },}

const Meditation = ({mantras,voice,time,homePage,interval}) => {
    
  const msg = new SpeechSynthesisUtterance()
  const inter=interval>0?interval*60:30
  let [startTime,setStartTime] = useState(0)
  let [timer,setTimer] = useState(time)
  let [timeLeft,setTimeLeft]=useState(time)
  let [volume,setVolume]=useState(0.5)

  let[sound,setSound]=useState()
  let[soundTxt,setSoundTxt]=useState('No sound')
  let[finished,setFinished]=useState(false)
  let[paused,setPaused]=useState(false)
  let[spoken,setSpoken]=useState(false)

  let [playMusic]=useSound(sound,{volume:volume})
  let [playRain]=useSound(rainSound,{volume:volume})
  let [playFire]=useSound(fireSound,{volume:volume})
  let [playWaves]=useSound(waveSound,{volume:volume})
  let [playGong]=useSound(gongSound,{volume:volume})

  const speechHandler = (msg) => {
    let rndInt =  Math.floor(Math.random() * mantras.length) 
    msg.text = mantras[rndInt]
    let win =window.speechSynthesis
    let voices=win.getVoices()
    msg.voice=voices[voice]
    win.speak(msg)
    // console.log(win.getVoices())
  }

  const handleSound=(v)=>{
    console.log(v)
    switch(v){
        case 'Rain':
            setSound(rainSound)
            setSoundTxt('Rain')
            // playRain()
            
            break;
        case 'Waves':
            setSound(waveSound)
            setSoundTxt('Waves')
            // playWaves()
            break;
        case 'Fire':
            setSound(fireSound)
            setSoundTxt('Fire')
            // playFire()
            break;
        case 'Tibetan Om':
          setSound(omSound)
          setSoundTxt('Tibetan Om')
          // playFire()
          break;
        case 'Theta Binaural':
          setSound(thetaSound)
          setSoundTxt('Theta Binaural')
          // playFire()
          break;
        case 'Delta Binaural':
          setSound(deltaSound)
          setSoundTxt('Delta Binaural')
          // playFire()
          break;

        case 'Alpha Binaural':
        setSound(alphaSound)
        setSoundTxt('Alpha Binaural')
        // playFire()
        break;

        default:
            setSound()
            setSoundTxt('No sound')
            break;
    }
    console.log(sound)
  }



  useEffect(() => {
    startTime==0 && setStartTime(Date.now())
    // console.log('start Time')
    // playMusic()
    // playRain()
  },[])
  useEffect(() => {
    spoken&&speechHandler(msg)
    
    // console.log('spoken:'+spoken+":"+timeLeft)
  },[spoken])

//   useEffect(() => {playMusic()},[sound])
  useEffect(() => {
        
    // clearInterval(interval)
    
    // console.log(timeRef.current +1)
    // timeRef.current=timeRef.current+1
    if(startTime!=0){
        
        interval= setInterval(() => {

       
        clearInterval(interval)
        if(!finished){
            clearInterval(interval)
    
            if (timeLeft>0 ){
              spoken&&setSpoken(false)
                
                // console.log(baseTime-Math.floor((Date.now() - startTime) / 1000))
                
                !paused&&setTimeLeft(timer-Math.floor((Date.now() - startTime) / 1000)>=0?timer-Math.floor((Date.now() - startTime) / 1000):0)
                if(timeLeft%inter==0&&!spoken){
                  setSpoken(true)
                }
                // console.log(inter)
                // console.log(timer+"|"+Date.now()+"-"+startTime)
                // setTimeLeft(timeLeft-1) 
                // clearInterval(interval)

            }
            if(timeLeft==0){
                
                setFinished(true)
                playGong()
                homePage()
                // setSound(null)
            }
    }
    return(()=>{clearInterval(interval)});
    },1000)}

},)

let timeFormat=(time)=>{
  let min,sec=0
  if(time>60){
      min= Math.trunc(time/60)
  }
  else{
      min=0
  }
  sec =time%60

  
  sec=sec>=10?sec:'0'+sec
  return(min+":"+sec)
  
}

  return (
    <Box height='100vh' pt={4} sx={{color:'primary.light',backgroundColor:'black',backgroundImage:`url(${backGround})`,backgroundRepeat:'no-repeat',backgroundPosition:'center', backgroundSize:{xs:'135%',md:'70%'}}}>
        <Box height='20vh' display='flex' alignItems='center' justifyContent='center'>
          <Typography variant="h4" align='center' fontSize={{xs:88,md:110}}>{timeFormat(timeLeft)}</Typography>
          </Box>

        <Box  p={4} display='flex' justifyContent="center">


<Select
// color='primary.light'
  sx={selectStyle}
    
    value={soundTxt}
    
    onChange={(event, newValue) => {handleSound(event.target.value)}}
    
  >
    {soundList.map((i,k) => (
          <MenuItem key={k} value={i}>
            {i}
          </MenuItem>
        ))}
  </Select>
        </Box>

        <Sound
      url={sound}
      playStatus={Sound.status.PLAYING}
    //   playFromPosition={300 /* in milliseconds */}
    //   onLoading={this.handleSongLoading}
    //   onPlaying={this.handleSongPlaying}
    //   onFinishedPlaying={this.handleSongFinishedPlaying}
    />
    <Box display="flex" justifyContent="center" gap={4} alignItems='center' py={{xs:4,md:8}}
    height='100%' >
      <Button variant='contained' onClick={homePage} sx={{fontSize:{xs:20,md:24},p:2,'&:hover':{backgroundColor:'primary.mainDark'}}}>Stop</Button>
      <Button variant='contained' 
      onClick={()=>{paused&&setStartTime(Date.now())
        paused&&setTimer(timeLeft)
        clearInterval(interval)
        setPaused(!paused)
        
      
    }}
    sx={{fontSize:{xs:20,md:24},p:2,'&:hover':{backgroundColor:'primary.mainDark'}}}
      >{paused?"Continue":"Pause"}</Button>
    </Box>
    </Box>
  )
}

export default Meditation